import React from 'react';
import classnames from 'classnames';
import style from './Alert.scss';
import useLayoutDirection from './Translations/useLayoutDirection';
const Alert = ({ title = '', message = 'Something went wrong. Please try again later.', type = 'danger', inline = false, className = '', }) => {
    const { isLayoutRTL } = useLayoutDirection();
    const content = (<>
      {title && <span className="text-semibold">{title}&nbsp;</span>}
      <span>{message}</span>
    </>);
    if (inline) {
        return <span className="text-danger">{content}</span>;
    }
    return (<div className={classnames(`alert alert-${type} no-border`, style.contentMessageAlign, className, {
        'text-right': isLayoutRTL,
    })}>
      {content}
    </div>);
};
export default Alert;
